import { Chip } from '@dxb-web-ui-framework/design-system';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CardStatuses } from '../../types';
import { mappingCardStatuses } from '../../utils/mappingCardStatuses';

export interface CardStatusChipProps {
  cardStatus?: CardStatuses;
}

const CardStatusChip: FC<CardStatusChipProps> = ({ cardStatus }) => {
  const { t } = useTranslation();

  if (!cardStatus) {
    return null;
  }

  return (
    <Chip
      data-testid='card-status'
      label={mappingCardStatuses(t)[cardStatus].statusChip.value}
      bgColor={mappingCardStatuses(t)[cardStatus].statusChip.color}
    />
  );
};

export { CardStatusChip };
